var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass: "menu--item_price",
      attrs: { "aria-label": _vm.priceLabel.length ? _vm.priceLabel : null },
    },
    [
      _vm._t("before-price"),
      _vm._v(" "),
      _vm.isPriceAriaHidden
        ? _c("span", {
            attrs: { "aria-hidden": "true" },
            domProps: { innerHTML: _vm._s(_vm.priceToDisplay) },
          })
        : _c("span", { domProps: { innerHTML: _vm._s(_vm.priceToDisplay) } }),
      _vm._v(" "),
      _vm._t("after-price"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }